import { useCallback, useState, useMemo } from "react";
import { trackEvent } from "services/bigbrain-service";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { componentStyles } from "./multi-products-pricing-component.scss";
import PricesAndFeaturesCardsPricing from "../prices-and-features-cards-pricing";
import FeatureTablePricing from "../features-table-pricing";
import { ProductSwitcher } from "./components/product-switcher";
import { PRICING_PAGE_PRODUCT_SWITCHER_CLICKED } from "/constants/bigbrain-event-types";

const MultiProductsPricingComponent = (props) => {
  const { pricesAndFeaturesCardsPricing, translate } = props;
  const {
    productName = undefined,
    isHomepagePricing = false,
    isApplyMaxDiffFeatures = false
  } = pricesAndFeaturesCardsPricing;
  const [selectedProductName, setSelectedProductName] = useState(productName);

  const selectedProductColors = useMemo(() => {
    const { primaryColor, secondaryColor } = productPricingConfig[selectedProductName];
    return { primaryColor, secondaryColor };
  }, [selectedProductName]);

  const onProductChange = useCallback(
    (newProductName) => {
      if (newProductName === selectedProductName) return;
      trackEvent(PRICING_PAGE_PRODUCT_SWITCHER_CLICKED, {
        info1: selectedProductName,
        info2: newProductName,
        productKind: selectedProductName
      });
      setSelectedProductName(newProductName);
    },

    [selectedProductName]
  );

  const getSelectedProductId = () => {
    const { productId } = productPricingConfig[selectedProductName];
    return productId;
  };

  return (
    <div
      className="multi-products-pricing-component"
      style={{
        "--primary-color": selectedProductColors.primaryColor,
        "--secondary-color": selectedProductColors.secondaryColor
      }}
    >
      <ProductSwitcher
        onProductChange={onProductChange}
        selectedProduct={selectedProductName}
        config={productPricingConfig}
        translate={translate}
      />

      <SignupFormComponent
        className="signup-form"
        ctaText={translate("signup.cta")}
        buttonColor={selectedProductColors.primaryColor}
        buttonSize="xs"
        useCtaText
        withButtonArrow
        signupProductId={getSelectedProductId()}
        extraData={{ productKind: selectedProductName, cta_name: "main_cta" }}
      />
      <PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingComponent
        {...props}
        productName={selectedProductName}
        isHomepagePricing={isHomepagePricing}
        isApplyMaxDiffFeatures={isApplyMaxDiffFeatures}
      />
      <FeatureTablePricing.FeaturesTablePricingComponent
        {...props}
        productName={selectedProductName}
        isHomepagePricing={isHomepagePricing}
        isApplyMaxDiffFeatures={isApplyMaxDiffFeatures}
      />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default MultiProductsPricingComponent;
